import {Line} from 'vue-chartjs';
// import zoom from 'chartjs-plugin-zoom';

export default Line.extend({
    props: {
        zoom: true,
        items: {
            default: () => { return []; },
        },
        labels: {
            default: () => { return []; },
        },
        toggle: {
            default: () => { return false; },
        },
        showLegend: {
            default: () => { return false; },
        },
        showGrid: {
            default: () => { return false; },
        },
        dashedLines: {
            default: () => { return false; },
        },
        chartData: {},
        layout: {
            padding: 10
        },
        options: {
            type: Object,
            default:  () => {
                return {
                    responsive: true,
                    showLegend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: false,
                            }
                        }]
                    },
                    pan: {
                        enabled: true,
                        mode: 'y'
                    },
                    zoom: {
                        enabled: true,
                        mode: 'y',
                    }
                }
            }
        }
    },
    mounted () {
        this.render();
        this.$root.$on('chart:changeYAxisTicks', this.changeYAxisTicks)
    },
    methods: {
        render: function () {
            this.renderChart({labels: this.labels, datasets: this.items }, this.options);
        },
        changeYAxisTicks: function (min, max, step) {
            this._chart.options.scales.yAxes[0].ticks.min = parseInt(min);
            this._chart.options.scales.yAxes[0].ticks.max = parseInt(max);
            this._chart.options.scales.yAxes[0].ticks.stepSize = parseInt(step);
            this._chart.update();
        },
        setDashedLines(dottedLines) {
            this._chart.data.datasets.forEach((d, index) => {
                this._chart.data.datasets[index].borderDash = dottedLines ? [20, 20] : [0,0];
            });
        },
        setLegend(legend) {
            this._chart.options.legend.display = legend;
        }
    },
    watch: {
        labels: {
            handler: function (newData, oldData) {
                this._chart.data.labels = newData;
                this._chart.update();
            },
        },
        items: {
            handler: function (newData, oldData) {
                this._chart.data.datasets = newData;
                this.setDashedLines(this.dashedLines);
                this.setLegend(this.showLegend);
                this._chart.update();
            }
        },
        toggle: {
            handler: function() {
                this._chart.data.datasets.forEach((d) => {
                });
            }
        },
        dashedLines: {
            handler: function(newData, oldData) {
                this.setDashedLines(newData);
                this._chart.update();
            }
        },
        showLegend: {
            handler: function (newData, oldData) {
                this.setLegend(newData);
                this._chart.update();
            }
        },
        showGrid: {
            handler: function (newData, oldData) {
                this._chart.options.scales.xAxes[0].gridLines.display = newData;
                this._chart.options.scales.yAxes[0].gridLines.display = newData;
                this._chart.update();
            }
        },
    },
})



// WEBPACK FOOTER //
// ./src/components/DefaultChart.js